module.exports = __webpack_public_path__ + "img/main-character.e701c283.png";